module.exports = __webpack_public_path__ + "img/bg-induce-03.d51b36be.png";